import React from 'react'
import { NAPIAvatarConstants } from '@adsk/napi-shared'
import { UserInfoType } from '../types/ActionTypes'
import { GetSelectionListByNameResult } from '@adsk/napi-api-client'
import { SELECTION_LIST_KEYS } from '../constants'
import _ from 'lodash'

export const eliminateDefaultXAvatar = (imageUrl?: string): string => {
	//Condition Added to allow profile picture component to treat default url as empty value
	if (imageUrl && NAPIAvatarConstants.DEFAULT_AVATAR_SUFFIX.test(imageUrl)) {
		return ''
	}
	return imageUrl || ''
}
export const getInitials = (value?: string): string => {
	try {
		if (value) {
			value = value.replace(/\bundefined\b/g, '')?.trim()
			const characters = value
				?.split(' ')
				.map((toSplit) => toSplit.split('')[0])
			return characters[1] ? `${characters[0]} ${characters[1]}` : characters[0]
		}
		return ''
	} catch (e) {
		// added for safety check
		return ''
	}
}

const extractDomainName = (url?: string) => {
	if (url) {
		const domainName = url.match(
			/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im
		)
		return domainName ? domainName[1] : ''
	}
	return ''
}

const useAsyncError = () => {
	const [_, setError] = React.useState()
	return React.useCallback(
		(e: any) => {
			setError(() => {
				throw e
			})
		},
		[setError]
	)
}

export const isBCNonGhostUser = (userInfo?: UserInfoType | undefined) => {
	return (
		userInfo?.bcUserId &&
		['companyName', 'companyType'].every((key: string) =>
			userInfo?.lockedFields?.includes(key)
		)
	)
}

const getSelectedCompanyTypes = (
	user: UserInfoType,
	selectionsList: Array<GetSelectionListByNameResult>
): Record<string, boolean> => {
	let results = {}
	selectionsList?.forEach((constantList) => {
		if (constantList.name === SELECTION_LIST_KEYS.COMPANY_TYPES) {
			let list = _.map(constantList.optionsList, 'value')
			const transformedCompanyType = (user?.companyType ?? []).reduce(
				(returnVal: any, key) => {
					returnVal[key] = true
					return returnVal
				},
				{}
			)
			const remainingCompanyTypes = _.difference(user?.companyType, list)
			results = {
				...transformedCompanyType,
				...(remainingCompanyTypes.length > 0 && {
					Other: true,
				}),
			}
		}
	})
	return results
}

const getSelectedCompanyTypesList = (companyTypes: Record<string, boolean>) => {
	return Object.keys(companyTypes).filter(
		(value) => companyTypes[value]
	) as string[]
}
const checkHasUserInfoChanged = (
	userInfo: UserInfoType,
	immutableUserInfo: UserInfoType,
	marketingCompanyTypeChanges: Record<string, boolean>,
	selectionsList: Array<GetSelectionListByNameResult>
) => {
	let user = {
		...userInfo,
		companyType: getSelectedCompanyTypesList(marketingCompanyTypeChanges),
	}
	let immutableUserInfoFiltered = {
		...immutableUserInfo,
		companyType: getSelectedCompanyTypesList(
			getSelectedCompanyTypes(immutableUserInfo, selectionsList)
		),
	}
	return !_.isEqual(user, immutableUserInfoFiltered)
}
export { extractDomainName, useAsyncError, checkHasUserInfoChanged }
